import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'

/**
 * Whether the current account can collaborate. That means the account is an org account, but
 * callers should treat it as the capability, not that specific condition, so the account rule
 * can change without touching call sites. Used to skip collaboration-only work like polling for
 * other people's changes.
 */
export function useIsAccountCollaborationCapable(): boolean {
  const authContext = useContext(AuthContext)
  return !!authContext?.userAccountData?.isOrgAccount
}
